export default "310087182f868dbf.svg"